import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {ReelState} from "../../core/reel/ReelState";
import {WalkOfShame} from "../WalkOfShame";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {WalkOfShameGameMode} from "../server/WalkOfShameGameMode";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {WalkOfShameReelController} from "../reels/WalkOfShameReelController";

export class WalkOfShameNormalIdlePresentation implements FlowStatePresentation {
    constructor() {
    }

    private static complete(flowStateController: FlowStateController): void {
        const wasBonus: boolean = WalkOfShame.model.parsedGameData && WalkOfShame.model.parsedGameData.mode.indexOf("FREESPIN") > -1 && WalkOfShame.model.parsedGameData.nextMode == WalkOfShameGameMode.NORMAL;
        if (wasBonus) {
        }

        flowStateController.finish();
    }

    private static async skip(flowStateController: FlowStateController): Promise<any> {
        await WalkOfShame.individualWin.stop();
        this.complete(flowStateController);
    }

    public start(flowStateController: FlowStateController): void {
        flowStateController.setSkipCallback(() => WalkOfShameNormalIdlePresentation.skip(flowStateController));

        WalkOfShame.reels.forEach((reel: WalkOfShameReelController) => {
            reel.reelState = ReelState.IDLE;
        });

        if (WalkOfShame.model.gameData?.nextMode != WalkOfShameGameMode.NORMAL) {
            WalkOfShameNormalIdlePresentation.complete(flowStateController);

            return;
        }

        if (!BelowStakeWinRestriction.isWinBelowPlayedBetValue() && !WalkOfShame.isActionSpinsActive) {
            WalkOfShame.individualWin.start();
        }
    }
}